































































































import { DashboardVendedorMetaAtual } from "@/services/dashboard-vendedor.service";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class WidgetMetaAtualVendedor extends Vue {
  @Prop({ required: true }) readonly metaAtual!: DashboardVendedorMetaAtual;
  @Prop({ required: true }) readonly pontosTotal: number = 0;
  @Prop({ required: true }) readonly fechado!: boolean;

  get percentualDiario(): number {
    return Math.round(Math.max(0, this.percentualDiarioReal));
  }

  get percentualDiarioReal(): number {
    if (!this.metaAtual.metaDiaria) {
      return 0;
    }

    return (this.metaAtual.pontuacaoHoje / this.metaAtual.metaDiaria) * 100;
  }

  get percentualDiarioBarra(): number {
    return this.normalizePercent(this.percentualDiarioReal);
  }

  get isMetaMensalBatida(): boolean {
    return this.metaAtual.percentual >= 100;
  }

  get valorBonusExibido(): number {
    return this.isMetaMensalBatida ? this.metaAtual.valorBonus : 0;
  }

  get isAbaixoDaProjecao(): boolean {
    return this.metaAtual.percentual < this.metaAtual.projecao;
  }

  get projecaoEmPontos(): number {
    return Math.round(
      (this.metaAtual.projecao / 100) * this.metaAtual.metaAtual,
    );
  }

  normalizePercent(value: number): number {
    if (!Number.isFinite(value)) {
      return 0;
    }

    return Math.max(0, Math.min(100, value));
  }

  formatCurrency(value: number): string {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }
}
